import { render } from "./PhotosModal.vue?vue&type=template&id=7b961132&scoped=true"
import script from "./PhotosModal.vue?vue&type=script&lang=js"
export * from "./PhotosModal.vue?vue&type=script&lang=js"

import "./PhotosModal.vue?vue&type=style&index=0&id=7b961132&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b961132"]])

export default __exports__